import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { AuthService, SKIP_REDIRECT } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService, public toast: ToastrService, public route:Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add access token to request if available
    // if (this.authService.isAuthenticated()) {
    //   request = this.addToken(request, this.authService.getAccessToken());
    // }

    return next.handle(request).pipe(
      catchError(error => {
        
        const skipRedirect = request.context.get(SKIP_REDIRECT);
        
        
        if (error.status === 401 && !request.url.includes('/consumer/refresh/')) {
          return this.handle401Error(request, next, skipRedirect);
        }
        return throwError(() => error);
        
      })
    );
  }

  /**
   * Add access token to request headers
   */
  private addToken(request: HttpRequest<any>, token: string | null) {

    if (!token) {
      return request;
    }

    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  /**
   * Handle 401 Unauthorized errors
   */
  private handle401Error(request: HttpRequest<any>, next: HttpHandler,skipRedirect: boolean = false): Observable<HttpEvent<any>> {
    console.log("inside handle 401")
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((response: any) => {

          this.isRefreshing = false;
          this.refreshTokenSubject.next(response.data.access_token);
          return next.handle(this.addToken(request, response.data.access_token));
        }),
        catchError((err) => {
          console.log("refresh error", err)
          this.isRefreshing = false;
          
          if (!skipRedirect && err.status == 401){
            this.toast.error("session expired, please login again")
            this.authService.finishLogout()
            
          }
          
          return throwError(() => err);
        })
      );
    } else {
      // Wait for token refresh to complete, then retry the request
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.addToken(request, token));
        })
      );
    }
  }
}